<script setup lang="ts">
    import OrganisationalTableFilter from '../components/organisationalTable/filter/OrganisationalTableFilter.vue';
    import OrganisationalTable from '../components/organisationalTable/table/OrganisationalTable.vue';
    import PageHeader from '../components/PageHeader.vue';
    import { __ } from '../stores/expressions';
</script>
<template>
    <div class="page-padding">
        <PageHeader>{{ __('organisational-results') }}</PageHeader>
        <div class="Card !p-0 mt-1.5 relative">
            <OrganisationalTableFilter>
                <template #table>
                    <OrganisationalTable />
                </template>
            </OrganisationalTableFilter>
        </div>
    </div>
</template>
